import { computed, toRefs } from '@vue/composition-api'

export default function Market9Players(props) {
  const { markets } = toRefs(props)

  const getPlayerName = (description) => {
    if (!description) {
      return ''
    }
    return description.replace(/\d+\+?/, '').trim()
  }
  const getCustomDesc = (description) => {
    if (description == null || description === '') {
      return ''
    }

    const matched = description.match(/(\d+\+?)/)
    return matched && matched[1]
  }

  const sortedMarkets = computed(() => {
    const tempMarkets = [...markets.value].filter((x) => x.status === 0 || x.status === 1)
    tempMarkets.sort((a, b) => {
      const oddsA = a.outcomes.map[a.outcomes.order[0]].odds
      const oddsB = b.outcomes.map[b.outcomes.order[0]].odds
      const diff = parseFloat(oddsA) - parseFloat(oddsB)
      if (diff > 0) return 1
      else if (diff < 0) return -1
      const playerNameA = getPlayerName(a.outcomes.map[a.outcomes.order[0]].description)
      const playerNameB = getPlayerName(b.outcomes.map[b.outcomes.order[0]].description)
      if (playerNameA < playerNameB) return -1
      else if (playerNameA > playerNameB) return 1
      return 0
    })
    return tempMarkets
  })

  return {
    getPlayerName,
    getCustomDesc,
    sortedMarkets
  }
}
